/*
 * action types
 */

// Trip Data
export const CHANGE_REFERENCE = 'CHANGE_REFERENCE';
export const CHANGE_PLANS = 'CHANGE_PLANS';
export const CHANGE_PLAN = 'CHANGE_PLAN';

// Relational Data
export const CHANGE_ALTERNATIVES = 'CHANGE_ALTERNATIVES';
export const CHANGE_FAVORITES = 'CHANGE_FAVORITES';
export const CHANGE_REACTIONS = 'CHANGE_REACTIONS';
export const CHANGE_RESERVATIONS = 'CHANGE_RESERVATIONS';

// Loadings
export const CHANGE_LOADING_REFERENCE = 'CHANGE_LOADING_REFERENCE';
export const CHANGE_LOADING_PLANS = 'CHANGE_LOADING_PLANS';
export const CHANGE_LOADING_ALTERNATIVES = 'CHANGE_LOADING_ALTERNATIVES';
export const CHANGE_LOADING_FAVORITES = 'CHANGE_LOADING_FAVORITES';
export const CHANGE_LOADING_REACTIONS = 'CHANGE_LOADING_REACTIONS';
export const CHANGE_LOADING_RESERVATIONS = 'CHANGE_LOADING_RESERVATIONS';

// Errors
export const SAVE_ERROR = 'SAVE_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';

// Clear
export const CLEAR = 'CLEAR';
